import { lazyLoadGoogleMaps } from "@shared/v2/widgets/googleMapsWidget";
import { i18n } from "@lib/i18n";

export const getNearestPoint = async (points, latLng) => {
  if (!points.length) {
    return null;
  }

  const maps = await lazyLoadGoogleMaps(i18n.language);

  const getGoogleLatLng = latLng => new maps.LatLng(latLng);

  const googleGeometry = window.google.maps.geometry.spherical;
  return points.reduce((acc, curr) => {
    const currPoint = googleGeometry.computeDistanceBetween(
      getGoogleLatLng(latLng),
      getGoogleLatLng({
        lat: Number(curr.geoLatitude),
        lng: Number(curr.geoLongitude),
      })
    );

    const prevPoint = googleGeometry.computeDistanceBetween(
      getGoogleLatLng(latLng),
      getGoogleLatLng({
        lat: Number(acc.geoLatitude),
        lng: Number(acc.geoLongitude),
      })
    );

    return currPoint < prevPoint ? curr : acc;
  });
};
